/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    cancelNewTaskSubtitle: 'Cancel',
    newTaskPlaceholder: 'Adding task...',
    addTaskButtonSubtitle: 'Add',
    removeTaskSubtitle: 'Delete Task'
};
//# sourceMappingURL=strings.js.map